<template>
    <v-autocomplete 
        v-bind="$attrs"
        :value="id" 
        @input="handleInput"
        :items="items"
        item-value="id"
        item-text="description"
    >
        <!-- Passa para o elemento filho todos os escopos do pai -->
        <template v-for="(_, name) in $scopedSlots" :slot="name" slot-scope="slotData"><slot :name="name" v-bind="slotData" /></template>
    </v-autocomplete>
</template>

<script>
export default {
    name: 'devolution-payment-types-picker',
    props: {
        id: {
            type: Number,
            default: null
        }
    },
    model: {
        prop: 'id',
        event: 'change'
    },
    data: function() {
        return {
            items: [],
            loading: false
        };
    },
    methods: {
        handleInput(value) {
            this.$emit('change', value);
        },
        async getItems() {
            this.loading = true;
            try {
                const response = await this.$http.get('/devolution_payment_types');
                this.items = response.data;
            } catch(error) {
                this.$error(error.message);
            } finally {
                this.loadin = false;
            }
        }
    },
    created() {
        this.getItems();
    }
}
</script>